import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { media } from "styled-bootstrap-grid";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion"

import Button from "../button";
import Container from "../container";
import { Paragraph } from "../typography";

const Wrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0px;
	transform: translateY(100%);
	transition: transform .4s ease-in-out;
  background-color: white;
  width: 100%;
  z-index: 2000;
	box-shadow: 0 -10px 40px -20px rgb(0 0 0 / 25%);
`;

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
	flex-direction: column;
	padding: 1.5rem 2rem;
	${media.lg`
		flex-direction: row;
	`}
`;
const StyledParagraph = styled(Paragraph)`
  margin-right: 0px;
	margin-bottom: 1rem;
	text-align: center;
	font-size: 14px;
	${media.md`
		font-size: 16px;
	`}
	${media.lg`
		margin-right: 2rem;
		margin-bottom: 0px;
		text-align: left;
	`}
	${media.lg`
		margin-right: 4rem;
	`}
`;

const Buttons = styled.div`
  display: flex;
`;

const Cookies = ({unMountCookieBanner, hideCookiesBanner}) => {
	// get cookies
	const getCookies = (cookieName) => {
		const name = cookieName + "=";
		const cookieDecoded = decodeURIComponent(document.cookie);
		const cArr = cookieDecoded .split('; ');
		let result;
		cArr.forEach(val => {
				if (val.indexOf(name) === 0) result = val.substring(name.length);
		})
		return result;
	}

	useEffect(() => {
		if (getCookies('cookieAnswered')) {
			unMountCookieBanner();
		}
	}, [])

	// set cookies
	const setCookie = (cookieName, cookieValue, expDays) => {
		let date = new Date();
		date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = `${cookieName}=${cookieValue}; ${expires}; path=/`
	}

	const answerCookie = (answer) => {
		setCookie('cookieAnswered', answer, 365);
		hideCookiesBanner();
	};

	const acceptCookie = () => {
		answerCookie(true);
		setCookieAccepted(true);
		setCookie('cookieAccepted', true, 365);
	}

	const denyCookie = () => {
		answerCookie(true);
	}

  return (
		<AnimatePresence>
				<Wrapper className={'cookieBanner'} animate={{translateY: '0%'}} exit={{translateY: '100%'}}>
					<StyledContainer>
						<StyledParagraph>
							Wir nutzen Cookies auf unserer Website. Einige von ihnen sind
							essentiell, während andere uns helfen, diese Website und Ihre
							Erfahrungen zu verbessern.
						</StyledParagraph>
						<Buttons>
							<Button
								to={`#`}
								text={`Ablehnen`}
								color={`black`}
								backgroundcolor={`white`}
								handleClick={(event) => {
									event.preventDefault();
									denyCookie();
								}}
							/>
							<Button
								to={`#`}
								text={`Akzeptieren`}
								color={`white`}
								backgroundcolor={`black`}
								handleClick={(event) => {
									event.preventDefault();
									acceptCookie();
								}}
							/>
						</Buttons>
					</StyledContainer>
				</Wrapper>
		</AnimatePresence>
  );
};

export default Cookies;
